export const wisconsin = {
  "55000": "Wisconsin",
  "55001": "Adams County",
  "55003": "Ashland County",
  "55005": "Barron County",
  "55007": "Bayfield County",
  "55009": "Brown County",
  "55011": "Buffalo County",
  "55013": "Burnett County",
  "55015": "Calumet County",
  "55017": "Chippewa County",
  "55019": "Clark County",
  "55021": "Columbia County",
  "55023": "Crawford County",
  "55025": "Dane County",
  "55027": "Dodge County",
  "55029": "Door County",
  "55031": "Douglas County",
  "55033": "Dunn County",
  "55035": "Eau Claire County",
  "55037": "Florence County",
  "55039": "Fond du Lac County",
  "55041": "Forest County",
  "55043": "Grant County",
  "55045": "Green County",
  "55047": "Green Lake County",
  "55049": "Iowa County",
  "55051": "Iron County",
  "55053": "Jackson County",
  "55055": "Jefferson County",
  "55057": "Juneau County",
  "55059": "Kenosha County",
  "55061": "Kewaunee County",
  "55063": "La Crosse County",
  "55065": "Lafayette County",
  "55067": "Langlade County",
  "55069": "Lincoln County",
  "55071": "Manitowoc County",
  "55073": "Marathon County",
  "55075": "Marinette County",
  "55077": "Marquette County",
  "55078": "Menominee County",
  "55079": "Milwaukee County",
  "55081": "Monroe County",
  "55083": "Oconto County",
  "55085": "Oneida County",
  "55087": "Outagamie County",
  "55089": "Ozaukee County",
  "55091": "Pepin County",
  "55093": "Pierce County",
  "55095": "Polk County",
  "55097": "Portage County",
  "55099": "Price County",
  "55101": "Racine County",
  "55103": "Richland County",
  "55105": "Rock County",
  "55107": "Rusk County",
  "55109": "St. Croix County",
  "55111": "Sauk County",
  "55113": "Sawyer County",
  "55115": "Shawano County",
  "55117": "Sheboygan County",
  "55119": "Taylor County",
  "55121": "Trempealeau County",
  "55123": "Vernon County",
  "55125": "Vilas County",
  "55127": "Walworth County",
  "55129": "Washburn County",
  "55131": "Washington County",
  "55133": "Waukesha County",
  "55135": "Waupaca County",
  "55137": "Waushara County",
  "55139": "Winnebago County",
  "55141": "Wood County",
};
